// 文件的结果展示组件---用于ai评阅后的结果

import FileType from '@/components/FileType';
import s from './style.module.scss';

import { Tooltip } from 'antd';
// import { VerticalAlignBottomOutlined } from '@ant-design/icons';
// import { getDownloadSignUrl } from '@/components/Upload/OssUpload';
import MyIcon from '@/components/MyIcon';
const ResultFile = (props) => {
    const { file, from = 'sender' } = props;
    const onDownload = async () => {
        window.open(file.file_url);
        // const res = await getDownloadSignUrl(file?.bucket, file?.object_id);
        // if (res?.success) {
        //     window.open(res.data);
        // }
    };
    return (
        <div className={s['result-files-wrap']} data-from={from}>
            <div className={s['file-item']}>
                <div className={s['file-type']}>
                    <FileType suffix={file?.ext_type} showType={false} fileName={file?.name}></FileType>
                </div>
                <div className={s['file-info']}>
                    <Tooltip title={file?.name}>
                        <div className={s['file-name']}>
                            {/* <span>评阅结果：</span> */}
                            <span className={s['file-name-span']}> {file?.name}</span>
                            {/* <span className={s['file-type-span']}> .{file?.ext_type}</span> */}
                        </div>
                    </Tooltip>

                    <div className={s['file-desc']}>
                        <span> AI生成</span>
                        <span className={s['file-time']}>{file?.create_time}</span>
                    </div>
                </div>
                <div onClick={onDownload} className={s['file-download']}>
                    <span className={s['file-download-icon']}>
                        <MyIcon type="icon-xiazai"></MyIcon>
                    </span>
                </div>
            </div>
        </div>
    );
};
export default ResultFile;
